module.exports = __webpack_public_path__ + "img/c-en-25.a31e3410.png";